import { ApolloError } from '@apollo/client';
import isEmpty from 'lodash/isEmpty';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'src/lib/translations';

interface ContentPresenterProps {
  children?: ReactNode;
  error: ApolloError | null;
}

export const ContentPresenter: FC<ContentPresenterProps> = ({
  children,
  error,
}) => {
  const { t } = useTranslation();

  if (!isEmpty(error)) {
    return <div>{t('general.error')}</div>;
  }
  return <>{children}</>;
};
